export const HOTJAR_BY_LANG = {
  la: { hjid: 3812385, hjsv:6 },
};
